import { LightDomStyles, OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';

import componentStyles from './outline-inline-link.css.lit';

/**
 * The Inline Link component.
 * @element outline-inline-link
 * @slot defaultSlot
 */
@customElement('outline-inline-link')
export class OutlineInlineLink extends OutlineElement {
  static styles = [componentStyles];

  lightDomStyles = new LightDomStyles(
    this,
    [componentStyles],
    this.tagName.toLowerCase()
  );

  render(): TemplateResult {
    return html`<slot></slot> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-inline-link': OutlineInlineLink;
  }
}
